export enum PermissionTargetType {
  User = 0,
  Group = 1
}